const BACKSPACE = 8;
const FIRST_NUMBER_KEY_CODE = 48;
const LAST_NUMBER_KEY_CODE = 57;

export const CVVMixin = {
    data() {
        return {
            ref: null
        }
    },
    methods: {
        addCVVMask(ref) {
            this.ref = ref;
            ref.addEventListener('keydown', this.onCVVKeyPress);
        },

        onCVVKeyPress(event) {
            //Accept only 4 numbers
            if (event.target.value.length > 3 && event.keyCode >= FIRST_NUMBER_KEY_CODE || event.keyCode > LAST_NUMBER_KEY_CODE) {
                event.preventDefault();
            }
        }
    },
    beforeDestroy() {
        if (this.ref) {
            this.ref.removeEventListener('keydown', this.onCVVKeyPress);
        }
    }
};


// WEBPACK FOOTER //
// ./src/mixins/CVVMixin.js